import { useState, useEffect } from 'react';

const CheckPlatform = () => {
    const [device, setDevice] = useState(false)

    useEffect(() => {
        const userAgent = navigator.userAgent;
        const platform = navigator.platform;

        // Device type codes: 1 = Linux, 2 = Android, 3 = Windows, 4 = iOS, 5 = macOS
        // This is determined for notification permissions and other platform-specific features.
        // More reasearch may be needed to refine the feature specifications.
        if (/MacIntel|MacPPC|Mac68K/.test(platform) || (userAgent.includes("Mac") && "ontouchend" in document)) {
            setDevice(false);
        } else if (/iPhone|iPad|iPod/.test(platform) || (userAgent.includes("iPhone") && "ontouchend" in document)) {
            setDevice(true);
        } else if (/Win/.test(platform)) {
            setDevice(false);
        } else if (/Android/.test(userAgent)) {
            setDevice(true);
        } else if (/Linux/.test(platform)) {
            setDevice(false);
        }
    }, []);

    return device
}

export { CheckPlatform }